import _ from 'underscore';
import {Form} from './form'
import {FormItem} from './formItem'
import {XmlTagInfo} from '../xmlTagProvider'

export default class FormGroup implements FormItem {

    public parent: FormGroup|undefined;

    public id: string = '';
    public tag: string = 'formGroup';
    public readonly className: string = 'FormGroup';
    public text: string = '';
    public name: string = '';
    public children: FormItem[] = [];
    public randomize: boolean = false;


    static fromXML(node: XmlTagInfo) {
        const text: XmlTagInfo = _(node.children).find(e => e.tag === 'text');
        const formGroup = new FormGroup;
        formGroup.id = '';
        formGroup.name = node.attributes.name || '';
        formGroup.text = text?.value || '';
        formGroup.children = _(node.children).without(text);
        formGroup.randomize = node.attributes['randomize'] === "yes";

        // Set form group as parent
        formGroup.children.forEach(fi => fi.parent = formGroup);

        // remove isEmpty groups
        formGroup.children = formGroup.children.filter(fi => fi.className === 'FormGroup' ? !(<FormGroup>fi).isEmpty() : true);

        return formGroup;
    }

    get firstId() {
        return this.children[0].firstId;
    }

    get nextFormId() {
        return _(this.children).last().nextFormId;
    }
    set nextFormId(nextForm) {
        // Set nextFormId to last Form of FormGroup
        _(this.children).last().nextFormId = nextForm;
    }

    public getFormsRecursive() : Form[] {
        let forms: Form[] = [];
        this.children.forEach((item) => {
            if( item.className === "Form" ) {
                forms.push(<Form>item);
            } else if (item.className === "FormGroup") {
                forms = forms.concat((<FormGroup>item).getFormsRecursive());
            }
        });

        return forms;
    }

    public getFormsRecursiveById(): {[id: string]: Form} {
        const formsById: {[id: string]: Form} = {};
        this.getFormsRecursive().forEach(form => formsById[form.id] = form);

        return formsById;
    }

    private isEmpty() {
        return this.children.length === 0;
    }
}


